export const allLanguages = [
    'en',
    'es',
    'fr',
    'de',
    'it',
    'pt',
    'ja',
    'ko',
    'zh',
    'hi',
    'bn',
    'th',
    'vi',
    'tr',
    'uk',
    'id',
    'pl',
];
export const languageNames = {
    en: 'English',
    es: 'Español',
    fr: 'Français',
    de: 'Deutsch',
    it: 'Italiano',
    pt: 'Português',
    ja: '日本語',
    ko: '한국어',
    zh: '中文',
    hi: 'हिन्दी',
    bn: 'বাংলা',
    th: 'ไทย',
    vi: 'Tiếng Việt',
    tr: 'Türkçe',
    uk: 'Українська',
    id: 'Bahasa Indonesia',
    pl: 'Polski',
};
//# sourceMappingURL=constants.js.map